import { Component, Inject, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { StorageManagerService } from '../../shared/services';
import { SubstanceLookupService } from '../../shared/services/substance-lookup.service';
import { SubstanceLookupModel } from '../../shared/models/substance-lookup.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-substance-lookup',
  templateUrl: './substance-lookup.component.html',
  styleUrls: ['./substance-lookup.component.scss']
})
export class SubstanceLookupComponent {

  @ViewChild('inputArea') inputArea;
  form: UntypedFormGroup;
  substanceLookup: SubstanceLookupModel;
  isCopying = false;
  generatedXml: string;
  userInput: any;
  loading = false;
  username = '';

  constructor(private renderer: Renderer2, private toastr: ToastrService, private storageManagerService: StorageManagerService,
    @Inject(DOCUMENT) private document: Document, private substanceLookupService: SubstanceLookupService) {
  }

  findMatch() {
    let input = this.inputArea.nativeElement.innerHTML;
    
    do { input = this.inputCleanup(input); } while (input.indexOf('<br') !== -1);
    this.substanceLookup = null;
    if (!input || this.loading) {
      if (!input) {
        this.clearText();
      }
      return;
    }
    this.loading = true;
    this.username = this.storageManagerService.read('userData').preferred_username;
    this.searchSubstanceLookup(input);
  }

  searchSubstanceLookup(input) {
    this.substanceLookupService.searchSubstanceLookup(input).subscribe({
      next: result => {
        this.substanceLookup = result;
        this.inputArea.nativeElement.innerHTML = "";
        let userInputArray = this.splitStringWithQuotes(result.userInput);
        for (const [index, item] of this.substanceLookup.substanceLookupResults.entries()) {
          if (!item.found) {
            let child = this.failedIngrediant(userInputArray[index]);
            this.renderer.appendChild(this.inputArea.nativeElement, child);
          } else {
            this.inputArea.nativeElement.innerHTML = this.inputArea.nativeElement.innerHTML + userInputArray[index];
          }
          if (index != this.substanceLookup.totalNumberOfIngredients - 1) {
            this.inputArea.nativeElement.innerHTML = this.inputArea.nativeElement.innerHTML + ", ";
          }
        }
        this.loading = false;
      },
      error: error => {
        this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
        this.loading = false;
      }
    });
  }

  inputCleanup(value: string): string {
    const tempDiv = this.document.createElement('div');
    tempDiv.innerHTML = value.replace(/<[^>]*>/g, ``);

    const elementsToReplace = tempDiv.querySelectorAll('span, div');
    elementsToReplace.forEach(element => {
      const textNode = document.createTextNode(element.innerHTML);
      element.parentNode.replaceChild(textNode, element);
    });

    const cleanedText = tempDiv.textContent.trim();

    return cleanedText;
  }

  failedIngrediant(text) {
    const child = this.document.createElement('span');
    child.style.color = "red";
    child.innerHTML = text;
    return child;
  }

  formatXml(xml, tab) {
    let formatted = '', indent = '';
    tab = tab || '\t';
    xml.split(/>\s*</).forEach(function (node) {
      if (node.match(/^\/\w/)) indent = indent.substring(tab.length);
      formatted += indent + '<' + node + '>\r\n';
      if (node.match(/^<?\w[^>]*[^\/]$/)) indent += tab;
    });
    return formatted.substring(1, formatted.length - 3);
  }

  clearText() {
    this.inputArea.nativeElement.innerHTML = '';
  }

  balanceQuotes(inputString) {
    const quotationCount = (inputString.match(/"/g) || []).length;
  
    if (quotationCount % 2 !== 0) {
      // If the count is odd, remove the last double quotation mark
      inputString = inputString.replace(/"([^"]*)$/, '$1');
    }
  
    return inputString;
  }

  splitStringWithQuotes(inputString) {
    inputString = this.balanceQuotes(inputString);
    const result = [];
    let insideQuotes = false;
    let currentToken = '';

    for (let char of inputString) {
      if (char === '"') {
        insideQuotes = !insideQuotes;
      } else if (char === ',' && !insideQuotes) {
        if (currentToken.trim()) {
          result.push(currentToken.trim());
        }
        currentToken = '';
        continue;
      }

      currentToken += char;
    }
    result.push(currentToken.trim());
    return result;
  }

  copy(id): void {
    this.isCopying = true;
    const from = document.getElementById(id);
    const range = document.createRange();
    window.getSelection().removeAllRanges();
    if (id == 'copyLog') {
      from.querySelector('table').style.width = '500px';
    }
    range.selectNode(from);
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    this.isCopying = false;
    if (id == 'copyLog') {
      from.querySelector('table').style.width = '100%';
    }
  }
}
